import {
  IQHUB_VERSION_REQ,
  IQHUB_VERSION_SUCCESS,
  IQHUB_VERSION_ERROR,
  IQHUB_VERSION_SET,
  IQ_PORTAL_VERSION_REQ,
  IQ_PORTAL_VERSION_SET,
  IQ_PORTAL_VERSION_ERROR
} from './version.type'
import ApiRest from '@/api/api-rest'

const state = {
  iqhubVersionStatus: '',
  iqhubVersion: '',
  iqportalVersion: ''
}

const getters = {
  iqhubVersionStatus: state => state.iqhubVersionStatus,
  iqhubVersion: state => state.iqhubVersion,
  iqportalVersion: state => state.iqportalVersion
}

const mutations = {
  [IQHUB_VERSION_SET]: (state, version) => {
    version = version.split('+')
    state.iqhubVersion = version[0]
  },
  [IQHUB_VERSION_REQ]: (state, version) => {
    state.iqhubVersionStatus = 'loading'
  },
  [IQHUB_VERSION_SUCCESS]: (state, version) => {
    state.iqhubVersionStatus = 'success'
  },
  [IQHUB_VERSION_ERROR]: (state, version) => {
    state.iqhubVersionStatus = 'errror'
  },
  [IQ_PORTAL_VERSION_REQ]: (state, errMsg) => {},
  [IQ_PORTAL_VERSION_SET]: (state, data) => {
    state.iqportalVersion = data
  },
  [IQ_PORTAL_VERSION_ERROR]: (state, errMsg) => {}
}

const actions = {
  [IQHUB_VERSION_REQ] (context, viewPref) {
    return new Promise((resolve, reject) => {
      context.commit(IQHUB_VERSION_REQ)
      ApiRest()
        .get('/version')
        .then(({ data }) => {
          context.commit(IQHUB_VERSION_SET, data.version)
          context.commit(IQHUB_VERSION_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(IQHUB_VERSION_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [IQ_PORTAL_VERSION_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(IQ_PORTAL_VERSION_REQ)
      ApiRest()
        .get('/iqportal-version')
        .then(({ data }) => {
          context.commit(IQ_PORTAL_VERSION_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(IQ_PORTAL_VERSION_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/version/version.module.js